/**
 * Перенос
 * `lib/src/presentation/pages/verify_admin/widgets/digit_keyboard/digit_keyboard_item.dart`.
 *
 * `sealed class` с четырьмя наследниками переносится размеченным
 * объединением: исчерпывающий `switch` по полю `kind` компилятор проверяет
 * так же, как Dart проверял `switch` по sealed-типу.
 *
 * `EquatableMixin` не переносится: элементы нигде не сравниваются между
 * собой — список фиксирован и создаётся один раз.
 */

export interface DigitKeyboardKey {
  readonly kind: 'key';
  readonly digit: number;
}

export interface DigitKeyboardBackspace {
  readonly kind: 'backspace';
}

export interface DigitKeyboardEmpty {
  readonly kind: 'empty';
}

export interface DigitKeyboardClose {
  readonly kind: 'close';
}

export type DigitKeyboardItem =
  | DigitKeyboardKey
  | DigitKeyboardBackspace
  | DigitKeyboardEmpty
  | DigitKeyboardClose;

/** `item.isBackspace` */
export function isBackspace(item: DigitKeyboardItem): boolean {
  return item.kind === 'backspace';
}

/** `item.isEmpty` */
export function isEmpty(item: DigitKeyboardItem): boolean {
  return item.kind === 'empty';
}

/** `item.isClose` */
export function isClose(item: DigitKeyboardItem): boolean {
  return item.kind === 'close';
}

/** `DigitKeyboardItem.items` — порядок кнопок на клавиатуре. */
export const DIGIT_KEYBOARD_ITEMS: readonly DigitKeyboardItem[] = [
  { kind: 'key', digit: 1 },
  { kind: 'key', digit: 2 },
  { kind: 'key', digit: 3 },
  { kind: 'key', digit: 4 },
  { kind: 'key', digit: 5 },
  { kind: 'key', digit: 6 },
  { kind: 'key', digit: 7 },
  { kind: 'key', digit: 8 },
  { kind: 'key', digit: 9 },
  { kind: 'close' },
  { kind: 'key', digit: 0 },
  { kind: 'backspace' },
];
